import React, { useEffect, useMemo, useState } from 'react'
import HeaderComponent from '../components/HeaderComponent'
import { getJwt, setJwt } from '../hooks/useJwt'
import { fetchWithTokenRefresh, useAuth } from '../providers/AuthContext'
import { navigate } from '@reach/router'
import { getRefreshToken, setRefreshToken } from '../hooks/useRefresh'
import { getFetcherWithResponse, postFetcherWithResponse } from '@startlibs/utils'
import { MENU_ITEMS } from '../utils/constants'
import { LoadingPage } from '../components/PageLoading'
import { setNotification } from '../components/Notifications'

export const AnalyticsPage = ({ instanceData }) => {

  const { menu } = useAuth();
  const baseURL = useMemo(() => process.env.NODE_ENV == 'development' ? "https://purviewimage-us-east-2.purview.net" : window?.purviewimageurl || "https://purviewimage-us-east-2.purview.net", []);

  if (!window.purviewimageurl) {
    console.warn("window.purviewimageurl is not defined");
  }
  // const defaultLogoURL = '/public/Purview_Logo_Horizontal_Main.png'
  const defaultLogoURL = '/spa/public/purview-logo.png'

  const title = instanceData?.title || 'Purview Image'
  const { isCheckingAuth, authUser, pacsDbName, setIsCheckingAuth, setMenu, setAuthUser, setPacsDbName } = useAuth()
  const [isLoading, setIsLoading] = useState(true)
  const [iframeSrc, setIframeSrc] = useState(false)
  const [canAccess, setCanAccess] = useState(false)
  
  useEffect(() => {
    document.title = title
  }, [title])

  useEffect(() => {

    const jwt = getJwt()
    if (jwt) {
      postFetcherWithResponse('/gw/refresh', {}, {
        headers: {
          'Authorization': 'Bearer ' + getRefreshToken(),
          'X-Auth-Token': jwt,
        }
      }).then(([data, res]) => {
        const authToken = res.headers.get('X-Auth-Token');
        setJwt(authToken, 'worklist');
        const refreshToken = res.headers.get('X-Refresh-Token');
        setRefreshToken(refreshToken, 'refreshToken');
        fetchWithTokenRefresh(
          getFetcherWithResponse,
          '/gw/worklist/options-and-rights',
          {},
          {},
          { jwt: authToken, setJwt: (jwt) => setJwt(jwt, 'worklist'), setRefreshToken: (refreshToken) => setRefreshToken(refreshToken, 'refreshToken') },
          'login',
          false
        ).then(([data, res]) => {
          // Filter the menus based on the presence of the name in data.auth array
          let availableMenuItens = MENU_ITEMS.filter(item => data.menus.includes(item.name));
          const isCustodianOfRecords = data?.options?.custodian || false
          const userLogin = data?.username || ''
          const isPurviewUser = userLogin.toLowerCase().endsWith('@purview.net') || userLogin.includes('purview@')

          if(isCustodianOfRecords && !isPurviewUser){
            availableMenuItens = availableMenuItens.filter(item => {
              return item.name !== 'reports' && item.name !== 'auditLogs' && item.name !== 'userManagement'
            })
          }
          setMenu(availableMenuItens)
          setAuthUser(data?.username)
          setPacsDbName(data?.pacsdbname)
          setIsCheckingAuth(false)
          
          const urlParams = new URLSearchParams(window.location.search)
          const _pacsdbName = data?.pacsdbname; // || urlParams.get("pacsdbName")
          const _user =  urlParams.get("user")
          const _studyDesc = urlParams.get("studyDesc")
          const _studyUid = urlParams.get("studyUid")
              
          // let isDev = process.env.NODE_ENV == 'development' 
          // if (isDev) {
          //   window.purviewimageurl = "https://purviewimage-us-east-2.purview.net";
          // }
          // let url = `${window.purviewimageurl}/data/?jwt=${authToken}${_pacsdbName ? `&pacsdbName=${_pacsdbName}` : ''}${_user ? `&user=${_user}` : ''}${_studyDesc ? `&studyDesc=${_studyDesc}` : ''}${_studyUid ? `&studyUid=${_studyUid}` : ''}&from=gw2`
          let url = `${baseURL}/data/?jwt=${authToken}${_pacsdbName ? `&pacsdbName=${_pacsdbName}` : ''}${_user ? `&user=${_user}` : ''}${_studyDesc ? `&studyDesc=${_studyDesc}` : ''}${_studyUid ? `&studyUid=${_studyUid}` : ''}&from=gw2`
          setIframeSrc(url)
          setIsLoading(false)
          
        })
          .catch(err => {
            console.log(err)
            if (err && err.length > 1) {
              const status = err[1]?.status || 0
              if (status === 403) {
                setNotification({ type: 'alert', msg: 'Your session has expired. Please login again.' })
                return
              }
              navigate('/login')
            }
          })
          .finally(() => {
            setIsCheckingAuth(false)
          })
      }).catch(([res, refreshErr]) => {
        // console.log(res, refreshErr)
        const refreshStatus = refreshErr?.status || 0;
        if (refreshStatus === 401) {
          localStorage.removeItem('worklist-jwt')
          localStorage.removeItem('refreshToken')
          navigate('login#session-expired')
        }
        throw refreshErr;
      })
    }

  }, [])

  useEffect(() => {
    if(menu) {
      if(menu.length > 0) {
        const pageIsEnabled = menu.find(item => item.path === '/analytics')
        if(!pageIsEnabled) {
          setNotification({ type: 'alert', msg: 'You do not have access to this page.' })
          setTimeout(() => {
            navigate('/')            
          }, 2000)
        }else{
          setCanAccess(true)
        }
      }
    }
  }, [menu])
  
  if (isCheckingAuth || isLoading || !iframeSrc || !canAccess) {
    return <><LoadingPage /></>
  }

  // return <p>test</p>

  return <div style={{ height: '100vh' }}>
    <HeaderComponent />
    <iframe 
      src={iframeSrc} 
      sandbox="allow-scripts allow-same-origin allow-downloads allow-top-navigation" 
      width={'100%'} 
      title={title} 
      style={{border: '0px', margin: '0px', padding: '0px', minHeight: 'calc(100% - 66px)'}}>
    </iframe>
  </div>
}